module.exports = __webpack_public_path__ + "img/right.5bb40c77.svg";